"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberToNumericalExpressionTransformer = void 0;
const inversify_1 = require("inversify");
const ServiceIdentifiers_1 = require("../../container/ServiceIdentifiers");
const NodeTransformationStage_1 = require("../../enums/node-transformers/NodeTransformationStage");
const AbstractNodeTransformer_1 = require("../AbstractNodeTransformer");
const NodeGuards_1 = require("../../node/NodeGuards");
const NodeFactory_1 = require("../../node/NodeFactory");
const NumberUtils_1 = require("../../utils/NumberUtils");
let NumberToNumericalExpressionTransformer = class NumberToNumericalExpressionTransformer extends AbstractNodeTransformer_1.AbstractNodeTransformer {
    constructor(numberNumericalExpressionAnalyzer, randomGenerator, options) {
        super(randomGenerator, options);
        this.numberNumericalExpressionAnalyzer = numberNumericalExpressionAnalyzer;
    }
    getVisitor(nodeTransformationStage) {
        if (!this.options.numbersToExpressions) {
            return null;
        }
        switch (nodeTransformationStage) {
            case NodeTransformationStage_1.NodeTransformationStage.Converting:
                return {
                    leave: (node, parentNode) => {
                        if (parentNode && NodeGuards_1.NodeGuards.isLiteralNode(node)) {
                            return this.transformNode(node, parentNode);
                        }
                    }
                };
            default:
                return null;
        }
    }
    transformNode(literalNode, parentNode) {
        if (typeof literalNode.value !== 'number') {
            return literalNode;
        }
        if (NodeGuards_1.NodeGuards.isPropertyNode(parentNode) && !parentNode.computed) {
            return literalNode;
        }
        const numberNumericalExpressionData = this.numberNumericalExpressionAnalyzer.analyze(literalNode.value);
        return this.convertNumericalExpressionDataToNode(numberNumericalExpressionData);
    }
    convertNumericalExpressionDataToNode(numberNumericalExpressionData, operator = '+') {
        var _a;
        const numberNumericalExpressionDataLength = numberNumericalExpressionData.length;
        const leftParts = numberNumericalExpressionDataLength > 1
            ? numberNumericalExpressionData.slice(0, numberNumericalExpressionDataLength - 1)
            : [numberNumericalExpressionData[0]];
        const rightParts = numberNumericalExpressionDataLength > 1
            ? numberNumericalExpressionData.slice(-1)
            : [];
        if (rightParts.length) {
            return this.convertPartsToBinaryExpression(operator, leftParts, rightParts);
        }
        const firstLeftPartOrNumber = (_a = leftParts[0]) !== null && _a !== void 0 ? _a : null;
        return Array.isArray(firstLeftPartOrNumber)
            ? this.convertNumericalExpressionDataToNode(firstLeftPartOrNumber, '*')
            : this.convertPartOrNumberToLiteralNode(firstLeftPartOrNumber);
    }
    convertPartsToBinaryExpression(operator, leftParts, rightParts) {
        const rightPartOrNumber = rightParts[0];
        if (Array.isArray(rightPartOrNumber)) {
            return NodeFactory_1.NodeFactory.binaryExpressionNode(operator, this.convertNumericalExpressionDataToNode(leftParts), this.convertNumericalExpressionDataToNode(rightPartOrNumber, '*'));
        }
        else {
            return NodeFactory_1.NodeFactory.binaryExpressionNode(operator, this.convertNumericalExpressionDataToNode(leftParts), this.convertPartOrNumberToLiteralNode(rightPartOrNumber));
        }
    }
    convertPartOrNumberToLiteralNode(partOrNumber) {
        const number = Array.isArray(partOrNumber)
            ? partOrNumber[0]
            : partOrNumber;
        const isPositiveNumber = NumberUtils_1.NumberUtils.isPositive(number);
        const literalNode = NodeFactory_1.NodeFactory.literalNode(Math.abs(number));
        return isPositiveNumber
            ? literalNode
            : NodeFactory_1.NodeFactory.unaryExpressionNode('-', literalNode);
    }
};
NumberToNumericalExpressionTransformer = __decorate([
    inversify_1.injectable(),
    __param(0, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.INumberNumericalExpressionAnalyzer)),
    __param(1, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.IRandomGenerator)),
    __param(2, inversify_1.inject(ServiceIdentifiers_1.ServiceIdentifiers.IOptions)),
    __metadata("design:paramtypes", [Object, Object, Object])
], NumberToNumericalExpressionTransformer);
exports.NumberToNumericalExpressionTransformer = NumberToNumericalExpressionTransformer;
